export default __webpack_public_path__ + "static/media/dynamite_explosion.fce2eb9b.mp3";